import { ThemeColors, cleanColors } from './engine';

/**
 * The product's own branding (Konductors, Alphapods, ...), from the frontend env.
 *
 * Used before sign-in, for clients without branding of their own, and for any
 * field a client leaves empty. Every value is optional: with no colours set the
 * app keeps its built-in look.
 */

const env = (name: string): string => (process.env[name] ?? '').trim();
const orNull = (value: string): string | null => value || null;

export interface ProductBranding {
  name: string;
  legalName: string | null;
  tagline: string | null;
  logoUrl: string | null;
  faviconUrl: string | null;
  supportEmail: string | null;
  supportUrl: string | null;
  termsUrl: string | null;
  privacyUrl: string | null;
  /** Shown as "Powered by <this>" in footers and chat widgets; empty hides it. */
  poweredBy: string | null;
  colors: ThemeColors;
  fontFamily: string | null;
}

export const PRODUCT: ProductBranding = {
  name: env('REACT_APP_PRODUCT_NAME') || env('REACT_APP_APPLICATION_NAME'),
  legalName: orNull(env('REACT_APP_PRODUCT_LEGAL_NAME')),
  tagline: orNull(env('REACT_APP_PRODUCT_TAGLINE')),
  logoUrl: orNull(env('REACT_APP_PRODUCT_LOGO_URL') || env('REACT_APP_APPLICATION_LOGO_URL')),
  faviconUrl: orNull(env('REACT_APP_PRODUCT_FAVICON_URL')),
  supportEmail: orNull(env('REACT_APP_PRODUCT_SUPPORT_EMAIL')),
  supportUrl: orNull(env('REACT_APP_PRODUCT_SUPPORT_URL')),
  termsUrl: orNull(env('REACT_APP_PRODUCT_TERMS_URL')),
  privacyUrl: orNull(env('REACT_APP_PRODUCT_PRIVACY_URL')),
  poweredBy: orNull(env('REACT_APP_POWERED_BY')),
  colors: cleanColors({
    primary: env('REACT_APP_THEME_PRIMARY_COLOR'),
    secondary: env('REACT_APP_THEME_SECONDARY_COLOR'),
    background: env('REACT_APP_THEME_BACKGROUND_COLOR'),
    text: env('REACT_APP_THEME_TEXT_COLOR'),
    header: env('REACT_APP_THEME_HEADER_COLOR'),
    footer: env('REACT_APP_THEME_FOOTER_COLOR'),
  }),
  fontFamily: orNull(env('REACT_APP_THEME_FONT')),
};
